import {PaletteColor, useTheme} from "@mui/material";
import {grey} from "@mui/material/colors";
import {css} from "@emotion/css";

// HeaderToggleButton is the on/off sibling of HeaderActionButton: same compact,
// bordered header-bar look, but it reflects an active state instead of opening a
// menu (no dropdown arrow).
export function HeaderToggleButton(props: {
    icon: any;
    label: string;
    active: boolean;
    color?: any;
    onClick(e: any): void;
}) {
    const theme = useTheme();
    const color = theme.palette[props.color || "primary"] as PaletteColor;

    return (
        <button
            className={buttonCss}
            onClick={(e) => props.onClick(e)}
            style={props.active ? {borderColor: color.main} : undefined}
        >
            <div style={{height: 2}} />
            <div style={{
                fontSize: "0.7rem",
                textAlign: "center",
                backgroundColor: color.main,
                color: color.contrastText,
                paddingLeft: 4,
                paddingRight: 4,
                borderRadius: 6,
                fontWeight: "bold",
                visibility: props.active ? "visible" : "hidden",
            }}>
                {props.active ? "On" : <>&nbsp;</>}
            </div>
            <div style={{height: 2}} />
            <div style={{fontSize: "1.2rem", color: props.active ? color.main : grey["700"]}}>
                {props.icon}
            </div>
            <div style={{
                fontSize: "0.7rem",
                textAlign: "center",
                paddingLeft: "0.5em",
                paddingRight: "0.5em",
            }}>
                {props.label}
            </div>
        </button>
    )
}

const buttonCss = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    background: "none",
    border: "1px solid " + grey["200"],
    borderRadius: 4,
    cursor: "pointer",
    padding: 0,
    minWidth: 44,

    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.1)"
    }
})
